var _rect, _path, _path2, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoodfirms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Goodfirms logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "#1b1e27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132 82h136c8 0 15 7 15 15v86c0 75-39 117-83 134-44-17-83-59-83-134V97c0-8 7-15 15-15z",
    fill: "#caa34a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m200 123 19 38 42 6-30 29 7 42-38-20-38 20 7-42-30-29 42-6z",
    fill: "#fff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 338,
    fill: "#fff",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 48,
    fontWeight: 400
  }, "Goodfirms")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoodfirms);
export default __webpack_public_path__ + "static/media/goodfirms.329abc2698949d89d3565a1871e88f6d.svg";
export { ForwardRef as ReactComponent };